import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: ${({ theme: { spacing } }) => spacing.spacing_08};
`;

export const ListItem = styled(FlexContainer)`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: ${({ theme: { spacing } }) => spacing.spacing_16};
`;

export const ListItemText = styled(FlexContainer)`
  width: 90%;
  p {
    line-height: 15.4px;
  }
`;
